<template>
  <div>
    <router-view />
    <notifications group="foo" position="top right" />
  </div>

</template>

<script>
import config from "@/helpers/config.js";
//import { mapGetters } from "vuex";
import {storeToRefs} from "pinia";
import { uselayoutStore } from '@/store/layoutstore'
import { mapState, mapActions } from "pinia"
export default {
  setup() {
    const layoutStore = uselayoutStore()
    const { headerDetails } = storeToRefs(layoutStore)
    return { headerDetailsGetter: headerDetails }
  },
  computed: {
    //...mapGetters(["headerDetailsGetter"]),
    ...mapState(uselayoutStore, ["headerDetailsGetter"]),
    headerDetails: function () {
      return this.headerDetailsGetter;
    },
  },
  watch: {
    headerDetailsGetter() {
      this.headerDetails1 = this.headerDetailsGetter;
      this.getFavIcon();
    },
    deep: true,
  },
  data() {
    return {
      headerDetails1: [],
      config: config,
    };
  },
  mounted() {
    // this.getFavIcon();
  },
  methods: {
    getFavIcon() {
      const favicon = document.getElementById("favicon");
      if (this.headerDetailsGetter.meta_header != undefined) {
        if (this.headerDetailsGetter.meta_header.favicon_url != undefined) {
          if (
            this.headerDetailsGetter.meta_header.favicon_url.includes("http")
          ) {
            favicon.href = this.headerDetailsGetter.meta_header.favicon_url;
          } else {
            favicon.href =
              "/backend" + this.headerDetailsGetter.meta_header.favicon_url;
          }

          if (this.headerDetailsGetter.edition == "cloud") {
            var selectedColor =
              this.headerDetailsGetter.meta_header.adminCloudColor;
          } else if (this.headerDetailsGetter.edition == "campus") {
            var selectedColor =
              this.headerDetailsGetter.meta_header.adminCampusColor;
          } else {
            var selectedColor =
              this.headerDetailsGetter.meta_header.adminIspColor;
          }
          const rootCssVariable = document.querySelector(":root");
          rootCssVariable.style.setProperty(
            "--color-50",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color1
          );
          rootCssVariable.style.setProperty(
            "--color-100",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color2
          );
          rootCssVariable.style.setProperty(
            "--color-200",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color3
          );
          rootCssVariable.style.setProperty(
            "--color-300",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color4
          );
          rootCssVariable.style.setProperty(
            "--color-400",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color5
          );
          rootCssVariable.style.setProperty(
            "--color-500",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color6
          );
          rootCssVariable.style.setProperty(
            "--color-600",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color7
          );
          rootCssVariable.style.setProperty(
            "--color-700",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color8
          );
          rootCssVariable.style.setProperty(
            "--color-800",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color9
          );
          rootCssVariable.style.setProperty(
            "--color-900",
            this.headerDetailsGetter.meta_header.colors[selectedColor].color10
          );
        }
      }
    },
  },
};
</script>

<style lang="css" >
@import "./assets/css/appv1.css";
@import "./assets/css/fonts.css";
@import "./assets/css/jazecustom.css";
@import "./assets/css/stylev1.css";
@import "./assets/css/stylev2.css";

:root {
  --color-50: #ffebee;
  --color-100: #ffcdd2;
  --color-200: #ef9a9a;
  --color-300: #e57373;
  --color-400: #ef5350;
  --color-500: #f44336;
  --color-600: #e53935;
  --color-700: #d32f2f;
  --color-800: #c62828;
  --color-900: #b71c1c;
}
</style>
